<template>
  <div>
    <!-- Footer -->
    <footer class="bg3 p-t-75 p-b-32 es-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-4 col-lg-4 p-b-20">
            <h4 class="stext-301 shopin cl0 p-b-30 f-font">eshops.lk</h4>

            <ul>
              <li class="p-b-10">
                <router-link
                  :to="{ name: 'home' }"
                  class="stext-107 cl7 hov-cl1 trans-04"
                >
                  Home
                </router-link>
              </li>

              <!-- <li class="p-b-10">
							<router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class="stext-107 cl7 hov-cl1 trans-04">
								Create Store
							</router-link>
						</li> -->

              <li class="p-b-10">
                <router-link
                  :to="{ name: 'about' }"
                  class="stext-107 cl7 hov-cl1 trans-04"
                >
                  About Us
                </router-link>
              </li>

              <li class="p-b-10">
                <router-link
                  :to="{ name: 'termsofuse' }"
                  class="stext-107 cl7 hov-cl1 trans-04"
                >
                  Terms of Use
                </router-link>
              </li>

              <li class="p-b-10">
                <router-link
                  :to="{ name: 'privacypolicy' }"
                  class="stext-107 cl7 hov-cl1 trans-04"
                >
                  Privacy Policy
                </router-link>
              </li>
            </ul>
            <ul class="social-media-icons mb-2 d-inline">
              <li style="">
                <a
                  href="https://www.facebook.com/Eshopslk-2212428785713128/"
                  class="px-0 ml-0 mr-2"
                  ><i
                    class="fa fa-facebook-official f-sm-link"
                    style="
                      font-size: 34px;
                      color: #3b5998;
                      background-color: #fff;
                      width: 30px;
                      height: 30px;
                      border-radius: 4px;
                      text-align: center;
                      vertical-align: middle;
                    "
                  ></i
                ></a>
              </li>
              <li>
                <a href="https://www.instagram.com/eshops.lk/" class="px-0 mx-2"
                  ><i
                    class="fa fa-instagram f-sm-link"
                    style="
                      font-size: 30px;
                      color: #fff;
                      background: #d6249f;
                      background: radial-gradient(
                        circle at 30% 107%,
                        #fdf497 0%,
                        #fdf497 5%,
                        #fd5949 45%,
                        #d6249f 60%,
                        #285aeb 90%
                      );
                      width: 32px;
                      height: 32px;
                      border-radius: 4px;
                      text-align: center;
                      vertical-align: middle;
                    "
                  ></i
                ></a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"
                  class="px-0 mx-2"
                  ><i
                    class="fa fa-youtube-square f-sm-link"
                    style="
                      font-size: 35px;
                      color: #ff0000;
                      background-color: #fff;
                      width: 30px;
                      height: 30px;
                      border-radius: 6px;
                      text-align: center;
                      vertical-align: middle;
                    "
                  ></i
                ></a>
              </li>
            </ul>
          </div>

          <div class="col-sm-4 col-lg-4 p-b-20">
            <h4 class="stext-301 cl0 p-b-30 f-font">Store</h4>

            <ul>
              <li class="p-b-10">
                <router-link
                  :to="{
                    name: 'storehome',
                    params: { storename: this.$route.params.storename },
                  }"
                  class="stext-107 cl7 hov-cl1 trans-04"
                >
                  Home
                </router-link>
              </li>

              <li class="p-b-10">
                <router-link
                  v-if="plan != 'Starter'"
                  :to="{
                    name: 'storecategories',
                    params: { storename: this.$route.params.storename },
                  }"
                  class="stext-107 cl7 hov-cl1 trans-04"
                >
                  Categories
                </router-link>
              </li>

              <li class="p-b-10">
                <router-link
                  :to="{
                    name: 'storeoffers',
                    params: { storename: this.$route.params.storename },
                  }"
                  class="stext-107 cl7 hov-cl1 trans-04"
                >
                  Offers
                </router-link>
              </li>

              <!-- <li class="p-b-10">
							<router-link  :to="{name: 'storeabout', params: {storename: this.$route.params.storename}}" class="stext-107 cl7 hov-cl1 trans-04">
								About
							</router-link>
						</li> -->

              <li class="p-b-10">
                <router-link
                  :to="{
                    name: 'storecontact',
                    params: { storename: this.$route.params.storename },
                  }"
                  class="stext-107 cl7 hov-cl1 trans-04"
                >
                  Contact
                </router-link>
              </li>
            </ul>
          </div>

          <div class="col-sm-4 col-lg-4 p-b-30">
            <h4 class="stext-301 cl0 p-b-20 f-font">GET IN TOUCH</h4>

            <p class="stext-107 cl7 size-201">
              Any questions? Let us know in store at {{ address }} or call us on
              +94 {{ tel1 }}
            </p>
            <div class="block-2 app-promotion">
              <a>
                <!-- Icon -->
                <img
                  src="../../../static/img/icons/footer-android-chrome-76x76.png"
                  alt="mobile-icon"
                  class="mt-3 mb-2"
                />
              </a>
              <p class="m-f-text text-white">
                Tap the Add to Home Screen Tab in Chrome Browser on Android or
                Safari Browser on IOS to Get the Splendid
                <span style="color: #fd6a02; font-size: 20px">Mobile App</span>
                Directly
              </p>
            </div>

            <!-- <div class="p-t-16">
						<a href="#" class="fs-18 cl7 hov-cl1 trans-04 m-r-16">
							<i class="fa fa-facebook"></i>
						</a>

					</div> -->
          </div>

          <!-- <div class="col-sm-6 col-lg-3 p-b-50">
					<h4 class="stext-301 cl0 p-b-30">
						Newsletter
					</h4>

					<form>
						<div class="wrap-input1 w-full p-b-4">
							<input class="input1 bg-none plh1 stext-107 cl7" type="text" name="email" placeholder="email@example.com">
							<div class="focus-input1 trans-04"></div>
						</div>

						<div class="p-t-18">
							<button class="flex-c-m stext-101 cl0 size-103 bg1 bor1 hov-btn2 p-lr-15 trans-04">
								Subscribe
							</button>
						</div>
					</form>
				</div> -->
        </div>

        <div class="p-t-1">
          <div class="flex-c-m flex-w p-b-18">
            <a class="m-all-1">
              <img
                src="../../../static/img/eshops-logo.png"
                alt="eshops-logo"
              />
            </a>
          </div>

          <p class="stext-107 cl6 txt-center">
            &copy; {{ new Date().getFullYear() }} eshops.lk | All Rights
            Reserved
          </p>
        </div>
      </div>
    </footer>

    <footer class="app-footer">
      <ul>
        <li @click="setRoute('storehome')">
          <i class="fa fa-home"></i>
          Home
        </li>
        <!-- <li @click="setRoute('storecategories')">
				<i class="fa fa-tag"></i>
				Categories
			</li> -->
        <li @click="setRoute('storeoffers')">
          <i class="fa fa-percent"></i>
          Offers
        </li>
        <li @click="setRoute('storecontact')">
          <i class="fa fa-phone"></i>
          Contact
        </li>
        <li
          v-if="
            this.$store.state.searchLocation != undefined &&
            this.$store.state.searchLocation != ''
          "
          @click="setRoute2('search', searchQuery)"
        >
          <i class="fa fa-search"></i>
          Search
        </li>
        <li v-if="user" @click="setRoute('myaccount')">
          <i class="fa fa-user"></i>
          Account
        </li>
        <li v-if="admin" @click="setRoute('admin')">
          <i class="fa fa-dashboard" style="font-size: 21px"></i>
          Admin
        </li>
      </ul>
    </footer>

    <!-- Back to top -->
    <div class="btn-back-to-top" id="myBtn">
      <span class="symbol-btn-back-to-top">
        <i class="fa fa-chevron-up"></i>
      </span>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
export default {
  data() {
    return {
      shops: [],
      address: "",
      email: "",
      tel1: "",
      tel2: "",
      plan: "",
      user: false,
      admin: false,
      cat: "",
      loc: "",
      searchQuery: {},
    };
  },
  methods: {
    setRoute(index) {
      this.$router.push({ name: index });
    },
    setRoute2(index, query) {
      this.$router.push({ name: index, query: query });
    },
  },
  created() {
    if (firebase.auth().currentUser) {
      if (firebase.auth().currentUser.displayName == null) {
        this.user = true;
      } else if (
        firebase.auth().currentUser.displayName == "shop owner" ||
        firebase.auth().currentUser.displayName == "starterplan shop owner"
      ) {
        this.admin = true;
      }
    }
    //console.log("navigator.onLine", navigator.onLine)
    if (this.$store.state.shops[this.$route.params.storename] != undefined) {
      this.address =
        this.$store.state.shops[this.$route.params.storename].details.address;
      this.email =
        this.$store.state.shops[this.$route.params.storename].details.email;
      this.tel1 =
        this.$store.state.shops[this.$route.params.storename].details.tel1;
      this.tel2 =
        this.$store.state.shops[this.$route.params.storename].details.tel2;
      this.plan = this.$store.state.shops[this.$route.params.storename].plan;
      this.cat = this.$store.state.shops[this.$route.params.storename].cat;
      this.loc = this.$store.state.searchLocation;
      this.searchQuery["cat"] = this.cat;
      this.searchQuery["loc"] = this.loc;
      //console.log('footer .$store.state.shops[this.$route.params.storename] is', this.$store.state.shops[this.$route.params.storename])
    } else {
      db.collection("shops")
        .where("owner", "==", this.$route.params.storename)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              shoptype: doc.data().shoptype,
              details: doc.data().details,
              plan: doc.data().plan,
              cat: doc.data().cat,
            };
            this.shops.push(data);
            this.address = this.shops[0].details.address;
            this.email = this.shops[0].details.email;
            this.tel1 = this.shops[0].details.tel1;
            this.tel2 = this.shops[0].details.tel2;
            this.plan = this.shops[0].plan;
            this.cat = this.shops[0].cat;
            this.loc = this.$store.state.searchLocation;
            this.searchQuery["cat"] = this.cat;
            this.searchQuery["loc"] = this.loc;

            //console.log("footer details are", this.shops[0].details)
            //console.log("url is", this.url)
          });
        });
    }
  },
};
</script>
 <style scoped>
.f-font {
  font-family: "Poppins";
}
.shopin {
  text-transform: none;
}
.social-media-icons {
  text-align: center !important;
}

.social-media-icons li {
  display: inline-block;
}

.social-media-icons li a {
  color: #848484;
  padding: 0 15px;
}

.social-media-icons li a:hover {
  color: #fff !important;
  text-decoration: none;
}
.app-footer {
  flex-shrink: 0;
  background: #ed4206;
  color: #444;
  padding: 7px;
  font-size: 14px;
  margin-top: 0px;
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.app-footer ul {
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  padding-inline-start: 0px;
  margin-block-end: 0px;
}

.app-footer ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.app-footer ul li i {
  font-size: 22px;
  color: #e4e7ed;
}
@media (max-width: 768px) {
  .app-footer {
    display: block;
  }
  .es-footer {
    margin-bottom: 55px;
  }
}
@media (max-width: 575px) {
  .m-f-text {
    font-size: 12px;
  }
}
</style>
 


// WEBPACK FOOTER //
// src/components/store/StoreFooter.vue